/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "27bc2aa9eb19321ed53b86722a72c83cabaff587";
